import ic_deskera from "./assets/companies/ic_deskera.png";
import ic_angel from "./assets/companies/ic_angel.png";
import ic_i2e from "./assets/companies/ic_i2e.png";
import ic_gameshastra from "./assets/companies/ic_gameshastra.png";
import ic_tata from "./assets/companies/ic_tata.png";
import ic_reliance from "./assets/companies/ic_reliance.png";
import ic_hungama from "./assets/companies/ic_hungama.png";

import ic_app_deskera from "./assets/apps/ic_deskera.png";
import ic_app_dashboard from "./assets/apps/ic_dashboard.png";
import ic_app_deskera_mobile from "./assets/apps/ic_deskera_app.png";
import ic_app_taskify from "./assets/apps/ic_taskify.png";
import ic_app_mappy from "./assets/apps/ic_mappy.png";
import ic_app_website from "./assets/apps/ic_website.png";
import ic_app_invoice from "./assets/apps/ic_invoice.png";
import ic_app_reports from "./assets/apps/ic_report.png";
import ic_app_shop from "./assets/apps/ic_shop.png";

export const MAX_PAGE_WIDTH = 1100;

export const SKILLS = {
  UI_UX: {
    title: "UI/UX",
    color: "data-grid-badge-color-10",
  },
  REACT: {
    title: "React JS",
    color: "data-grid-badge-color-3",
  },
  REACT_NATIVE: {
    title: "React Native",
    color: "data-grid-badge-color-4",
  },
  IOS: {
    title: "iOS / Swift",
    color: "data-grid-badge-color-5",
  },
  ANDROID: {
    title: "Android",
    color: "data-grid-badge-color-6",
  },
  JAVASCRIPT: {
    title: "Javascript",
    color: "data-grid-badge-color-7",
  },
  HTML: {
    title: "HTML",
    color: "data-grid-badge-color-8",
  },
  CSS: {
    title: "CSS",
    color: "data-grid-badge-color-9",
  },
  MAC: {
    title: "Apple Watch",
    color: "data-grid-badge-color-1",
  },
};

export const EXPERIENCE = {
  DESKERA: {
    title: "Deskera Pte. Ltd (Jun 2019 - Present)",
    position: "Technology Lead",
    location: "Singapore",
    logo: ic_deskera,
  },
  ANGEL: {
    title: "Angel Broking (Jun 2019 - Present)",
    position: "Chief Manager - Technology",
    location: "Mumbai, India",
    logo: ic_angel,
  },
  I2E: {
    title: "I2E Consulting (Jun 2019 - Present)",
    position: "Tech Lead",
    location: "Mumbai, India",
    logo: ic_i2e,
  },
  GAMESHASTRA: {
    title: "Gameshastra (Jun 2019 - Present)",
    position: "Tech Lead",
    location: "Hyderabad, India",
    logo: ic_gameshastra,
  },
  TATA: {
    title: "TATA Interactive Solutions (Jun 2019 - Present)",
    position: "Sr. Developer",
    location: "Hyderabad, India",
    logo: ic_tata,
  },
  HUNGAMA: {
    title: "Hungama Digital (Jun 2019 - Present)",
    position: "Sr. Developer",
    location: "Mumbai, India",
    logo: ic_hungama,
  },
  RELIANCE: {
    title: "Reliance Games (Jun 2019 - Present)",
    position: "Jr. Developer",
    location: "Pune, India",
    logo: ic_reliance,
  },
};

export const APPS = {
  DESKERA: {
    title: "Deskera Website",
    description: "All in One accounting software",
    icon: ic_app_deskera,
    url: "https://www.deskera.com",
    skills: [SKILLS.REACT, SKILLS.JAVASCRIPT, SKILLS.HTML, SKILLS.CSS],
  },
  DASHBOARD: {
    title: "Deskera Dashboard",
    description: "All in One accounting software",
    icon: ic_app_dashboard,
    url: "https://go.deskera.com",
    skills: [
      SKILLS.REACT,
      SKILLS.JAVASCRIPT,
      SKILLS.UI_UX,
      SKILLS.HTML,
      SKILLS.CSS,
    ],
  },
  DESKERA_APP: {
    title: "Deskera Hydrid App",
    description: "All in One accounting software",
    icon: ic_app_deskera_mobile,
    url: "https://apps.apple.com/app/id1463523833",
    skills: [
      SKILLS.REACT_NATIVE,
      SKILLS.IOS,
      SKILLS.ANDROID,
      SKILLS.JAVASCRIPT,
      SKILLS.CSS,
    ],
  },
  TASKIFY_APP: {
    title: "Taskify iOS App",
    description: "All in One accounting software",
    icon: ic_app_taskify,
    url: "https://apps.apple.com/app/id1282867263",
    skills: [SKILLS.IOS, SKILLS.UI_UX],
  },
  MAPPY_APP: {
    title: "Mappy iOS App",
    description: "All in One accounting software",
    icon: ic_app_mappy,
    url: "https://apps.apple.com/app/id1476911776",
    skills: [SKILLS.IOS, SKILLS.UI_UX],
  },
  WEBSITE_BUILDER_APP: {
    title: "Website builder / designer",
    description: "All in One accounting software",
    icon: ic_app_website,
    url: "https://website-builder.deskera.com/",
    skills: [SKILLS.UI_UX, SKILLS.REACT, SKILLS.JAVASCRIPT],
  },
  INVOICE_APP: {
    title: "Invoice designer",
    description: "All in One accounting software",
    icon: ic_app_invoice,
    url: "https://invoice-generator.deskera.com/",
    skills: [
      SKILLS.UI_UX,
      SKILLS.REACT,
      SKILLS.JAVASCRIPT,
      SKILLS.HTML,
      SKILLS.CSS,
    ],
  },
  REPORT_APP: {
    title: "Report Generator",
    description: "All in One accounting software",
    icon: ic_app_reports,
    url: "https://report-builder.deskera.com/",
    skills: [
      SKILLS.UI_UX,
      SKILLS.REACT,
      SKILLS.JAVASCRIPT,
      SKILLS.HTML,
      SKILLS.CSS,
    ],
  },
  SHOP_APP: {
    title: "E-Commerce platform",
    description: "All in One accounting software",
    icon: ic_app_shop,
    url: "https://store-builder.deskera.com/",
    skills: [
      SKILLS.REACT,
      SKILLS.JAVASCRIPT,
      SKILLS.UI_UX,
      SKILLS.HTML,
      SKILLS.CSS,
    ],
  },
};
